export const protectedRouteActionText = 'Switch accounts';

export const protectedRouteWarnMessage =
  'Your account access is disabled. Please contact your account admin to continue.';

export const protectedRouteReturnText = 'Need help?';

export const protectedRouteWarnTitle = 'You don’t have permission to view this page.';
